import { test } from 'ramda';

export const isValidEmail = test(/^(?=.{1,256}$)[^\s@]+@[^\s@]+\.[^\s@]+$/);

/* eslint-disable no-useless-escape */
export const isValidUrl = test(/(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/);
/* eslint-enable no-useless-escape */

export const isValidPhoneNumber = (number: string): boolean => !/\D/.test(number);
